import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// The storefront's own serving domain (www.xpeditionz.co.nz) and its API's
// configured backend URL (the bare apex domain, xpeditionz.co.nz) can differ.
// That turns every API call into a cross-origin request to a domain that has
// proven less reliable at the edge than the one actually serving the page,
// which was traced as the cause of pages intermittently hanging on "Loading…"
// in production. Rewriting outgoing requests to be relative (same-origin)
// removes that cross-origin hop entirely — the platform's ingress already
// proxies /api on whichever origin served the page, in both preview and
// production, so this is safe everywhere.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (BACKEND_URL) {
  axios.interceptors.request.use((config) => {
    if (config.url && config.url.startsWith(BACKEND_URL)) {
      config.url = config.url.slice(BACKEND_URL.length) || "/";
    }
    return config;
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
